import {
  VuexModule, Module, Action,
} from 'vuex-module-decorators';
import Vue from 'vue';
import {
  BASE_URL,
  M_POST,
  FETCH_POINT,
  ACTIVE_POINT,
} from '@/utils/api';

@Module({ name: 'Point' })
export default class Point extends VuexModule {
  @Action
  fetchPoint() {
    return Vue.axios({
      url: BASE_URL + FETCH_POINT,
      data: {},
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code !== 0) {
          throw data.status;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }

  @Action
  activePoint(id: any) {
    return Vue.axios({
      url: BASE_URL + ACTIVE_POINT,
      data: id,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code !== 0) {
          throw data.status;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }
}
